module.exports = __webpack_public_path__ + "images/emoji/telephone.ffc0002ae0d868f7eaa9.png";